import { Box } from "@mui/material";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import {
  PlyrLayout,
  plyrLayoutIcons,
} from "@vidstack/react/player/layouts/plyr";
import { FC } from "react";

import "@vidstack/react/player/styles/plyr/theme.css";

interface Props {
  src: string;
}

const VideoPlayer: FC<Props> = ({ src }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "200px", md: "400px" },
        backgroundColor: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      
      <MediaPlayer
        title="Sarodi"
        src={src}
        id="sarodi-video"
      >
        <MediaProvider />
        <PlyrLayout icons={plyrLayoutIcons} />
      </MediaPlayer>
    </Box>
  );
};

export default VideoPlayer;
